import React from "react";
import {
  Box,
  Typography,
  Divider,
  useTheme,
} from "@mui/material";

const WorkPulsePolicy = () => {
  const theme = useTheme();

  return (
    <Box sx={{ bgcolor: "#f4f6f8", py: 6, px: { xs: 3, sm: 8, md: 12 }, minHeight: "100vh" }}>
      <Box
        sx={{
          bgcolor: "#ffffff",
          borderRadius: 2,
          boxShadow: 2,
          p: { xs: 3, sm: 5, md: 7 },
        }}
      >
        <Typography
          variant="h3"
          component="h1"
          gutterBottom
          sx={{ fontWeight: 700, color: "#0A1929" }}
        >
          Privacy Policy
        </Typography>

        <Typography
          variant="subtitle2"
          gutterBottom
          sx={{ color: "text.secondary", mb: 3 }}
        >
          Effective Date: August 01, 2025
        </Typography>

        <Typography variant="body1" sx={{ mb: 3 }}>
          This Privacy Policy outlines how <strong>WorkPulse.in</strong> ("we", "us", "our") collects, uses,
          stores, and protects your personal information when you access or use our website and
          platform, <strong>WorkPulse.in</strong>.
        </Typography>

        <Divider sx={{ mb: 4 }} />

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          1. Information We Collect
        </Typography>

        <Typography variant="body1" sx={{ mb: 3 }}>
        <ul style={{ marginTop: 0, paddingLeft: "1.5rem", marginBottom: "1rem" }}>
          <li><strong>Personal Information:</strong> name, email, company, designation, etc.</li>
          <li><strong>Account & Login:</strong> credentials, roles, etc.</li>
          <li><strong>Usage Data:</strong> IP address, browser info, activity logs.</li>
          <li><strong>Cookies:</strong> for performance and personalization.</li>
        </ul>
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
          2. How We Use Your Information
        </Typography>
        <Typography variant="body1">
          To operate the platform, personalize user experience, maintain security, and improve services.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mt: 4, mb: 1 }}>
          3. Data Sharing and Disclosure
        </Typography>
        <Typography variant="body1">
          No selling of data. Shared only with trusted services and as legally required.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mt: 4, mb: 1 }}>
          4. Your Rights
        </Typography>
        <Typography variant="body1">
          You can request access, correction, or deletion of your data by contacting us.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mt: 4, mb: 1 }}>
          5. Contact
        </Typography>
        <Typography variant="body1">
          For any questions, please contact us at <strong>support@workpulse.in</strong>.
        </Typography>
      </Box>
    </Box>
  );
};

export default WorkPulsePolicy;
